module.exports = __webpack_public_path__ + "static/media/online-learning.ec92136c.png";